import { Alert } from "@mui/material";
import { ForbiddenError } from "../errors/forbiddenError.ts";
import { UnauthenticatedError } from "../errors/unauthenticatedError.ts";
import { useTranslator } from "../i18n/translator.ts";

export const ErrorDisplay = ({ error }: { error: Error }) => {
  const translator = useTranslator();

  return (
    <Alert severity="error">
      {translator(
        error instanceof UnauthenticatedError
          ? "pleaseLogIn"
          : error instanceof ForbiddenError
            ? "noPermissionToViewProject"
            : "unknownErrorTryAgainLater",
      )}
    </Alert>
  );
};
